// TODO Make locale aware.
export function formatNumberAbbr(
  value: number,
  decimalPlaces: number,
  unabbreviatedDecimalPlaces?: number
): string {
  const suffixes = ['K', 'M', 'B', 'T']
  const thousands = Math.floor(Math.log10(Math.abs(value)) / 3)

  // Try not to abbreviate if we don't have to.
  if (unabbreviatedDecimalPlaces !== undefined) {
    const digits = Math.floor(Math.log10(Math.abs(value)))

    const unabbreviatedLength =
      digits +
      // The decimal point.
      (unabbreviatedDecimalPlaces > 0 ? 1 : 0) +
      unabbreviatedDecimalPlaces +
      // The number of commas.
      thousands

    const maxAbbreviatedLength = (decimalPlaces > 0 ? decimalPlaces + 1 : 0) + 4

    // Check if the number is shorter than the abbreviated form.
    if (unabbreviatedLength <= maxAbbreviatedLength) {
      return value.toLocaleString(undefined, {
        maximumFractionDigits: unabbreviatedDecimalPlaces,
        minimumFractionDigits: unabbreviatedDecimalPlaces
      })
    }
  }

  const digits = (value / 1000 ** Math.max(1, thousands)).toLocaleString(undefined, {
    maximumFractionDigits: decimalPlaces,
    minimumFractionDigits: decimalPlaces
  })

  const suffixIndex = Math.max(0, thousands - 1)

  return `${digits}${suffixes[suffixIndex]}`
}

export function range(start, end) {
  const ans = []
  for (let i = start; i <= end; i++) {
    ans.push(i)
  }
  return ans
}

export function fixedPrecisionRound(value: number, precision: number): number {
  const multiplier = 10 ** (precision || 0)
  return Math.round(value * multiplier) / multiplier
}

export function parseToFixedPrecision(
  anyNumber: string,
  precision: number,
  defaultReturn = 0
): number {
  if (!anyNumber || anyNumber === '') return defaultReturn
  const result = fixedPrecisionRound(parseFloat(anyNumber), precision)
  return Number.isNaN(result) ? defaultReturn : result
}

export const displayNumber = (value: number, dp: number, defaultReturn = '–') =>
  typeof value === 'number' && !Number.isNaN(value) ? value.toFixed(dp) : defaultReturn
export const displayPercentage = (value: number, dp: number, defaultReturn = '–') =>
  typeof value === 'number' && !Number.isNaN(value)
    ? `${(value * 100).toFixed(dp)}%`
    : defaultReturn

export function formatUnits(value: number, dp = 6): string {
  // Convert the value to a string with six decimal places
  let formattedValue = value.toFixed(dp)

  // Remove trailing zeros and the decimal point if no decimal part remains
  formattedValue = formattedValue.replace(/(\.\d*[1-9])0+$|\.0*$/, '$1')

  return Number(formattedValue).toLocaleString('en-GB', { maximumFractionDigits: 6 })
}
